import { gql } from "@apollo/client";

export const GET_CLIENT_INSURANCE_INFO = gql`
  query clientQuery($clientId: Int!) {
    insurancePlans {
      id
      name
    }

    client(clientId: $clientId) {
      id
      name
      lastModifiedOn
      acceptedInsurancePlans {
        name
        id
      }
    }
  }
`;
